import { create } from "zustand";

const useHomePopupStore = create((set) => ({
    display: "none",
    loaded: false,

    setVisibility: (visibility) => set({ display: visibility }),
    setLoad: (loaded) => set({ loaded }),
}));

export default useHomePopupStore;
